export function isFolderTester() {
    return window.USER && 'isFolderTester' in window.USER ? !!window.USER.isFolderTester : false;
}
